import React from 'react';
import { Col, Row, Input } from "reactstrap";
import {inject, observer} from "mobx-react";
import FormSelect from '../../../comum/components/FormSelect';
import { IconeDelete } from '../../../comum/components/Icones';
import FormInput from "../../../comum/components/FormInput";
import {statusNotaTranslate} from "../../../../utils/formatar";

@inject("store")
@observer
export default class CardNotaFiscalContainersLivre extends React.Component {
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.controller = this.props.controller;

        this.isStatusPendente = _.get(this.props.container, 'Status')===undefined || _.get(this.props.container, 'Status')==='P';
        this.status = statusNotaTranslate(_.get(this.props.container, 'Status'));
    }

    render() {
        return (
            this.appStore.isMobile()
                ? <Row>
                    <FormInput titulo={ "Container" } sm={12} md={12}
                                bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura : !this.isStatusPendente}
                                objeto={ this.props.container }
                                dado={ "CodCntr" }
                                limiteMaximo={11}
                                itensValor="id" itensLabel="ds"
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.CodCntr`, event) }  />
                    <FormInput titulo={ "Booking" } sm={12} md={12}
                                bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura :!this.isStatusPendente}
                                objeto={ this.props.container }
                                dado={ "NumBooking" }
                                limiteMaximo={20}
                                itensValor="id" itensLabel="ds"
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.NumBooking`, event) }  />
                    <FormInput titulo={ "Status" } sm={12} md={12}
                                bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura :!this.isStatusPendente}
                                objeto={ this.props.container }
                                dado={ "Status" }
                                itensValor="id" itensLabel="ds"
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.Status`, event) }  />
                    <a className="ml-3" onClick={this.props.remover}>Excluir</a>
                </Row>
                : <Row>
                    <FormInput sm={12} md={3}
                                bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura : !this.isStatusPendente}
                                objeto={ this.props.container }
                                dado={ "CodCntr" }
                                limiteMaximo={11}
                                itensValor="id" itensLabel="ds"
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.CodCntr`, event) }  />
                    <FormInput sm={12} md={3}
                                bloqueado={this.props.somenteLeitura ? this.props.somenteLeitura : !this.isStatusPendente}
                                objeto={ this.props.container }
                                dado={ "NumBooking" }
                                limiteMaximo={20}
                                onChange={ (event) => this.props.setDado(`${this.props.dado}.NumBooking`, event) }
                    />
                    <Col sm={12} md={3} >
                        <Input
                               disabled={true}
                               value={this.status ? this.status : ''}
                               onChange={() => this.props.setDado(`${this.props.dado}.Status`, 0)}/>
                    </Col>

                    {this.isStatusPendente &&
                        <Col sm={12} md={1} className="mt-2 pt-1">
                            {this.props.somenteLeitura ? <div /> : 
                            <IconeDelete title={"Excluir"} tamanho="lg"
                                     onClick={this.props.remover}/>}
                        </Col>
                    }
                </Row>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/nota-fiscal-cadastrar/components/CardNotaFiscalContainersLivre.js